module.exports = __webpack_public_path__ + "static/media/paragon-corp-white.e705509b.png";